module.exports = "<app-header></app-header>\r\n<div class=\"row\">\r\n    <div class=\"col-md-3 pr-0\">\r\n        <app-leftnav></app-leftnav>\r\n    </div>\r\n    <div class=\"col-md-9 details px-0\">\r\n        <p class=\"header\" tabindex=\"0\">Contact Us</p>\r\n        <app-map></app-map>\r\n    </div>\r\n</div>\r\n<app-footer></app-footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/contactus/contactus.component.html
// module id = ./src/app/contactus/contactus.component.html
// module chunks = main